"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _makeStylesInternal = _interopRequireDefault(require("../../makeStyles/makeStylesInternal"));
var _TextLink = _interopRequireDefault(require("../../TextLink"));
var _Breadcrumbs = _interopRequireDefault(require("@mui/material/Breadcrumbs"));
var _initial = _interopRequireDefault(require("lodash/initial"));
var _tokens = require("../../styles/tokens");
var useStyles = (0, _makeStylesInternal.default)(function () {
  return {
    breadcrumbs: {
      fontFamily: _tokens.fontFamilyDefault,
      fontSize: _tokens.fontSizeSmall
    }
  };
});

/**
 * Renders a breadcrumb element representing the current position in the hierarchy.
 */
var MasterDetailBreadcrumbs = function MasterDetailBreadcrumbs(props) {
  var selectedPath = props.selectedPath,
    rootTitle = props.rootTitle,
    onNodeSelect = props.onNodeSelect;
  var localClasses = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.default, {
    className: localClasses.breadcrumbs,
    maxItems: 3
  }, /*#__PURE__*/_react.default.createElement(_TextLink.default, {
    key: "active",
    disabled: true
  }, rootTitle), (0, _initial.default)(selectedPath).map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_TextLink.default, {
      key: item.nodeId,
      onClick: function onClick(e) {
        return onNodeSelect(e, item);
      }
    }, item.label);
  })));
};
MasterDetailBreadcrumbs.propTypes = {
  selectedPath: _propTypes.default.array,
  rootTitle: _propTypes.default.string,
  onNodeSelect: _propTypes.default.func
};
var _default = MasterDetailBreadcrumbs;
exports.default = _default;